import React from 'react';
import {Constants} from "./Constants";
import {useRenderableData} from "./hooks/useRenderableData";

interface DelayedSearchBarProps {
    value?: string;
    performSearch: Function;
    placeholder?: string;
}


let delayedSearchTimeout: number | undefined = undefined;

export let DelayedSearchBar = function (props: DelayedSearchBarProps) {
    const renderableData = useRenderableData({
        searchText: props.value || '',
        prevValue: props.value || ''
    })

    if (props.value !== renderableData.prevValue) {
        renderableData.updateAndRender({
            searchText: props.value || '',
            prevValue: props.value
        })
    }

    function clearDelayedSearchTimeout() {
        window.clearTimeout(delayedSearchTimeout);
        delayedSearchTimeout = undefined;
    }

    function handleSearchTextChange(event: React.ChangeEvent<HTMLInputElement>) {
        clearDelayedSearchTimeout();
        let updatedSearchText = event.target.value;

        renderableData.updateAndRender({searchText: updatedSearchText});

        clearDelayedSearchTimeout();
        delayedSearchTimeout = window.setTimeout(function () {
            props.performSearch(updatedSearchText);
        }, Constants.searchDelayMs);
    }

    return (
        <div className="search-bar-outer-container">
            <div className="search-bar-container">
                <div className="search-bar-icon-container">
                    <img
                        className="search-bar-icon"
                        src={
                            renderableData.searchText !== props.value ?
                                Constants.loadingIndicatorSrc :
                                "/static/images/search-textcolor.svg"
                        }
                    />
                </div>
                <div className="search-bar-field-container">
                    <input
                        className="search-bar-field"
                        value={renderableData.searchText}
                        onChange={handleSearchTextChange}
                        placeholder={props.placeholder}
                    />
                </div>
            </div>
        </div>
    );
};
